// extracted by mini-css-extract-plugin
export var grid = "_2n-0";
export var span1 = "_2n-2";
export var span10 = "_2n-b";
export var span10L = "_2n-z";
export var span10M = "_2n-n";
export var span10Xl = "_2n-1b";
export var span11 = "_2n-c";
export var span11L = "_2n-10";
export var span11M = "_2n-o";
export var span11Xl = "_2n-1c";
export var span12 = "_2n-d";
export var span12L = "_2n-11";
export var span12M = "_2n-p";
export var span12Xl = "_2n-1d";
export var span1L = "_2n-q";
export var span1M = "_2n-e";
export var span1Xl = "_2n-12";
export var span2 = "_2n-3";
export var span2L = "_2n-r";
export var span2M = "_2n-f";
export var span2Xl = "_2n-13";
export var span3 = "_2n-4";
export var span3L = "_2n-s";
export var span3M = "_2n-g";
export var span3Xl = "_2n-14";
export var span4 = "_2n-5";
export var span4L = "_2n-t";
export var span4M = "_2n-h";
export var span4Xl = "_2n-15";
export var span5 = "_2n-6";
export var span5L = "_2n-u";
export var span5M = "_2n-i";
export var span5Xl = "_2n-16";
export var span6 = "_2n-7";
export var span6L = "_2n-v";
export var span6M = "_2n-j";
export var span6Xl = "_2n-17";
export var span7 = "_2n-8";
export var span7L = "_2n-w";
export var span7M = "_2n-k";
export var span7Xl = "_2n-18";
export var span8 = "_2n-9";
export var span8L = "_2n-x";
export var span8M = "_2n-l";
export var span8Xl = "_2n-19";
export var span9 = "_2n-a";
export var span9L = "_2n-y";
export var span9M = "_2n-m";
export var span9Xl = "_2n-1a";
export var stretch = "_2n-1";